
export var gameSettings = {
    playerSpeed: 200
};